/* tslint:disable */
/* eslint-disable */
/**
 * Dictionary
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: $project.version
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Country } from '../models';
// @ts-ignore
import type { MerchantCategoryGroup } from '../models';
// @ts-ignore
import type { State } from '../models';
/**
 * CommonTermsApi - axios parameter creator
 * @export
 */
export const CommonTermsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of countries with their name and ISO code (ISO 3166-1) displayed. The name field lists valid human-readable country names and the alpha code fields list the two- and three-digit ISO country code that corresponds with the country name.
         * @summary Get List of Countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/common/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of merchant category codes with their name and category displayed.
         * @summary Get List of Merchant Category Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCategoryCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/common/mcc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of USA States with their name and 2-letter abbreviation displayed.
         * @summary Get List of USA States
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsaStates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/common/states/usa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonTermsApi - functional programming interface
 * @export
 */
export const CommonTermsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonTermsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a list of countries with their name and ISO code (ISO 3166-1) displayed. The name field lists valid human-readable country names and the alpha code fields list the two- and three-digit ISO country code that corresponds with the country name.
         * @summary Get List of Countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Country>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommonTermsApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of merchant category codes with their name and category displayed.
         * @summary Get List of Merchant Category Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantCategoryCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantCategoryGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantCategoryCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommonTermsApi.getMerchantCategoryCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of USA States with their name and 2-letter abbreviation displayed.
         * @summary Get List of USA States
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsaStates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<State>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsaStates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommonTermsApi.getUsaStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommonTermsApi - factory interface
 * @export
 */
export const CommonTermsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonTermsApiFp(configuration)
    return {
        /**
         * Retrieves a list of countries with their name and ISO code (ISO 3166-1) displayed. The name field lists valid human-readable country names and the alpha code fields list the two- and three-digit ISO country code that corresponds with the country name.
         * @summary Get List of Countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<Country>> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of merchant category codes with their name and category displayed.
         * @summary Get List of Merchant Category Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCategoryCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<MerchantCategoryGroup>> {
            return localVarFp.getMerchantCategoryCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of USA States with their name and 2-letter abbreviation displayed.
         * @summary Get List of USA States
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsaStates(options?: RawAxiosRequestConfig): AxiosPromise<Array<State>> {
            return localVarFp.getUsaStates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonTermsApi - object-oriented interface
 * @export
 * @class CommonTermsApi
 * @extends {BaseAPI}
 */
export class CommonTermsApi extends BaseAPI {
    /**
     * Retrieves a list of countries with their name and ISO code (ISO 3166-1) displayed. The name field lists valid human-readable country names and the alpha code fields list the two- and three-digit ISO country code that corresponds with the country name.
     * @summary Get List of Countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonTermsApi
     */
    public getCountries(options?: RawAxiosRequestConfig) {
        return CommonTermsApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of merchant category codes with their name and category displayed.
     * @summary Get List of Merchant Category Codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonTermsApi
     */
    public getMerchantCategoryCodes(options?: RawAxiosRequestConfig) {
        return CommonTermsApiFp(this.configuration).getMerchantCategoryCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of USA States with their name and 2-letter abbreviation displayed.
     * @summary Get List of USA States
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonTermsApi
     */
    public getUsaStates(options?: RawAxiosRequestConfig) {
        return CommonTermsApiFp(this.configuration).getUsaStates(options).then((request) => request(this.axios, this.basePath));
    }
}

